module.exports = __webpack_public_path__ + "media/application/images/2018/popup-close-2@x4-46ca01cc62f35a7d2aaa10411c8a7f24.png";